export default __webpack_public_path__ + "static/media/textsearch_standard.6b5cb7ce.svg";